module.exports = __webpack_public_path__ + "static/hero2-b5f3ce89cd7f1e74300c083dd55669a5.png";